import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Logo from './Logo'

const CUSTOMER_PORTAL_URL = 'https://app.aegisserves.com/login'

const NAV_LINKS = [
  { label: 'HOME', path: '/' },
  { label: 'ABOUT US', path: '/about' },
  { label: 'SERVICES', path: '/services' },
  { label: 'INDUSTRIES', path: '/industries' },
  { label: 'SOLUTIONS', path: '/solutions' },
  { label: 'RESOURCES', path: '/resources' },
  { label: 'CONTACT', path: '/contact' },
]

function isActive(pathname, path) {
  if (path === '/') return pathname === '/'
  return pathname === path || pathname.startsWith(`${path}/`)
}

function openCustomerPortal() {
  const gd = typeof window !== 'undefined' ? window.GorillaDesk : undefined
  if (typeof gd === 'function') {
    gd('showPortal')
    return
  }
  window.location.href = CUSTOMER_PORTAL_URL
}

export default function SiteHeader() {
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <header className="sticky top-0 z-30 bg-black border-b border-neutral-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex items-center justify-between h-20 gap-3 min-w-0">
          <Link to="/" className="min-w-0 flex-shrink" onClick={() => setMobileOpen(false)}>
            <Logo />
          </Link>

          <nav className="hidden xl:flex items-center gap-5 flex-shrink-0">
            {NAV_LINKS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-xs font-semibold tracking-widest uppercase transition-colors ${
                  isActive(location.pathname, item.path)
                    ? 'text-aps-red'
                    : 'text-white hover:text-aps-red'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
            <button
              type="button"
              onClick={openCustomerPortal}
              className="btn-aps-red hidden xl:inline-flex px-5 py-2.5"
            >
              Customer Portal <span className="ml-1">&gt;</span>
            </button>
            <button
              type="button"
              className="xl:hidden p-2 -mr-2 text-white"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <nav className="xl:hidden pb-4 flex flex-col gap-2">
            {NAV_LINKS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileOpen(false)}
                className={`py-2 text-xs font-semibold tracking-widest uppercase ${
                  isActive(location.pathname, item.path) ? 'text-aps-red' : 'text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <button
              type="button"
              onClick={() => {
                setMobileOpen(false)
                openCustomerPortal()
              }}
              className="btn-aps-red mt-2 w-full justify-center px-5 py-2.5"
            >
              Customer Portal <span className="ml-1">&gt;</span>
            </button>
          </nav>
        )}
      </div>
    </header>
  )
}
